export const LOGIN = '/login'
export const SHAREDLEAD = '/shared-lead'
export const CRMWEBHOOK = '/master/crm-webhook'
export const SOURCESYSTEM = '/master/source-system'
export const FORGOTPASSWORD = '/forgot-password'
export const RESETPASSWORD = '/reset-password'
export const DASHBOARD = '/dashboard'
export const ADDNEWLEAD = '/add-new-lead'
export const LEADLIST = '/leadList'
export const LEADPOOL = '/central-lead'
export const ADDLEADEXISTCOMPANY = '/add-lead-to-existing-company'
export const COMPANIES = '/companies'
export const ADDNEWCOMPANY = '/add-new-company-form'
export const ADDNEWPOC = '/add-new-poc'
export const ADDCOMPANYPOC = '/add-new-company-poc'
export const ROLES = '/roles'
export const PAGES = '/pages'
export const USERS = '/users'
export const NEWROLE = '/new-role'
export const NEWPAGE = '/new-page'
export const PROFILE = '/profile'
export const SUPPORT = '/support'
export const TICKETDETAIL = '/ticket-detail'
export const COMPANY = '/company'
export const MYLEADS = '/my-leads'
export const POC = '/poc'
export const LeadAssignReport = '/assign-report'
export const LeadCreationReport = '/creation-report'
export const EMPLOYEEPERFORMANCE = '/employee-performance-report'
export const COMPARISONCHART = '/comparison-chart'
export const EMAILSETTING = '/email-settings'
export const GSTSETTING = '/gst-setting'
export const UpdatePassword = '/update-password'
export const EXTRACTFORMCONTENT = '/extract-form-content'
export const LEADDETAIL = '/lead-details'
export const MYLEADEDIT = '/my-lead-edit'

export const INDUSTRYTYPES = '/master/industry-types'
export const DESIGNATION = '/master/designation'
export const COUNTRY = '/master/country'
export const STATE = '/master/state'
export const CITY = '/master/city'
export const SOURCE = '/master/source'
export const STATUS = '/master/status'
export const TEAMMANAGEMENT = '/master/team-management'
export const SALESSTAGE = '/master/sales-stage'
export const ADDMEMBER = '/master/add-member'
export const LEADREQUIREMENT = '/lead-requirement'
export const MYTEAMLEAD = '/my-team-lead'
export const SERVICEINTERESTEDIN = '/master/service-intrested'
export const FIELDMASKINGSETTING = '/master/field-masking-setting'
export const PRODUCT = '/master/product'
export const WEBSITESETTINGS = '/master/website-settings'


export const ADDQUICKCOMPANYPOC = '/quick-lead'
export const COUNTRYASSIGNEDMEMBERS = '/CountryAssignedMember'
export const DUPLICATELEADSETTINGS = '/Duplicateleadsettings'
export const DUPLICATELEAD = '/Duplicatelead'
export const EMAITEMPLATE = '/EmailTemplate'
export const LEADACCEPTANCEHISTORY = '/lead-acceptance-history'
export const BULKUPLOADLEAD = '/bulk-upload-lead'
export const MEETING = '/meetings'



export const FOLLOWUPLIST = '/reminders-list'
export const SIGNATURE = '/signature'
export const CREATEDLEAD = '/created-lead'
export const MYTEAMCREATEDLEAD = '/my-team-created-lead'